import { createBaseQuery as fetchBaseQuery } from '../baseQuery';
import { baseURL } from '../../../config';
import { createApi } from '@reduxjs/toolkit/query/react';

const baseUrl = `${baseURL}/newsletter/`;

export const newsletterApiService = createApi({
    reducerPath: 'newsletterApi',
    baseQuery: fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const { token } = getState().authSlice; // Destructuring 'token' from authSlice state
            if (token) {
                headers.set('Authorization', `Bearer ${token}`); // Setting the Authorization header
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getNewsletter: builder.query({
            query: () => ({
                url: 'get',
                method: 'GET',
            }),
        }),
        subscribeToNewsletter: builder.mutation({
            query: ({ id, email }) => ({
                url: `subscribe/${id}`,
                method: 'POST',
                body: { email },
            }),
        }),
    }),
});

export const {
    useGetNewsletterQuery,
    useSubscribeToNewsletterMutation
} = newsletterApiService;
